export default __webpack_public_path__ + "static/media/Chhattisgarhi_am_2.7ac3a765.mp3";